import { isKameleoonEnabled } from './lendAPIUtils';

let kameleoonEnvironmentLogged = false;

export const normalizeTabNameForKameleoon = (tabName: string): string => {
  if (!tabName) return '';

  return tabName
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .replace(/([a-zA-Z])(\d)/g, '$1-$2')
    .replace(/(\d)([a-zA-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const sendKameleoonGoalConversion = (
  goalName: string,
  productType: string = 'LendAPI'
): void => {
  const logPrefix = `[LendAPI ${productType}][Kameleoon][TRACKING]`;

  if (!kameleoonEnvironmentLogged) {
    kameleoonEnvironmentLogged = true;
    console.log(`${logPrefix} Kameleoon events: ${isKameleoonEnabled() ? 'Enabled' : 'Disabled'}`);
  }

  if (!goalName) {
    console.warn(`${logPrefix} Goal name is empty, skipping conversion`);
    return;
  }

  if ((window as any).kameleoonQueue) {
    (window as any).kameleoonQueue.push(['Goals.processConversion', goalName]);
    console.log(`${logPrefix} Custom goal conversion sent:`, goalName);
  } else {
    console.warn(`${logPrefix} kameleoonQueue is not available`);
  }
};

const findCustomGoalOverride = (
  tabName: string,
  customGoalMapping?: Record<string, string>
): string | undefined => {
  if (!customGoalMapping) return undefined;

  const normalizedTabName = normalizeTabNameForKameleoon(tabName);

  const match = Object.entries(customGoalMapping).find(
    ([key]) => normalizeTabNameForKameleoon(key) === normalizedTabName
  );

  return match ? match[1] : undefined;
};

export const handleKameleoonTracking = (
  tabName: string,
  productType: string,
  customGoalMapping?: Record<string, string>
): void => {
  if (!tabName) return;

  const normalizedTabName = normalizeTabNameForKameleoon(tabName);
  const overrideGoal = findCustomGoalOverride(tabName, customGoalMapping);
  const productSlug = productType.toLowerCase().replace(/\s+/g, '');
  const goalName = overrideGoal || `custom-lendapi-${productSlug}-${normalizedTabName}`;

  sendKameleoonGoalConversion(goalName, productType);
};
